import { parseNumberFilter, parseTextFilter, toFilterText, toPeriodSearch } from '@/utils/filters';
import type { BatchSearch } from '../types/publish.types';

type FilterValues = Record<string, string>;

type BatchFilterSearch = Pick<
  BatchSearch,
  'dateFrom' | 'dateTo' | 'trnDateFrom' | 'trnDateTo' | 'userId'
>;

export function toBatchFilterValues(search: BatchFilterSearch): FilterValues {
  return {
    dateFrom: toFilterText(search.dateFrom),
    dateTo: toFilterText(search.dateTo),
    trnDateFrom: toFilterText(search.trnDateFrom),
    trnDateTo: toFilterText(search.trnDateTo),
    userId: toFilterText(search.userId),
  };
}

export function toBatchFilterSearch(values: FilterValues): BatchFilterSearch {
  return {
    ...toPeriodSearch(values),
    trnDateFrom: parseTextFilter(values.trnDateFrom),
    trnDateTo: parseTextFilter(values.trnDateTo),
    userId: parseNumberFilter(values.userId),
  };
}
